import { render, staticRenderFns } from "./MultiplesODS.vue?vue&type=template&id=5aa049ee&scoped=true"
import script from "./MultiplesODS.vue?vue&type=script&lang=js"
export * from "./MultiplesODS.vue?vue&type=script&lang=js"
import style0 from "./MultiplesODS.vue?vue&type=style&index=0&id=5aa049ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa049ee",
  null
  
)

export default component.exports